import styled from 'styled-components';
import { StyledCard } from '../../../Card.component';
import { StyledButton } from '../../../Button.component';
import { StyledBaseModal } from '../../BaseModal.component';
import { StyledSpinnerView } from '../../../Spinner.component';

export const StyledAttachModal = styled.div`
  display: flex;
  max-height: 895px;
  animation: ${({ theme }) => theme.animations.slide.modal} 0.2s ease-in-out
    forwards;

  ${StyledCard} {
    width: 300px;
    height: auto;
  }
`;

export const StyledSelectOptionDescription = styled.div`
  color: ${({ theme }) => theme.colors.LABEL};
`;

export const StyledSelectOption = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const StyledCandidateEditModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px 0 0 0;
  gap: 10px;

  ${StyledButton} {
    min-width: 100px;
  }
`;

export const StyledCandidateEditModalStack = styled.div`
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;

  & > div {
    align-self: start;
  }
`;

export const StyledCandidateEditModal = styled.div`
  ${StyledBaseModal} {
    width: 800px;
  }

  ${StyledSpinnerView} {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: ${({ theme }) => theme.colors.CARD};
    border-radius: 8px;
  }
`;

export const StyledStatusGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
